import theme from '../../theme';
import FredChart from '../../components/FredChart';
import PageHeader from '../../components/PageHeader';
import { useEffect } from 'react';

const FredPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Interest Rates - Austrian Process";
  }, []);

  return (
    <div className="page-container page-container-wide">
      <PageHeader
        title="The Fed Funds Rate"
        description="A managed signal, and what Austrian Economics says about it."
      />

      <div style={{
        borderBottom: '1px solid rgba(184, 149, 90, 0.2)',
        paddingBottom: '2rem',
        marginBottom: '2rem',
      }}>
        <ul style={{ fontSize: '15px', lineHeight: '2', color: theme.textPrimary, paddingLeft: '.5rem', margin: 0 }}>
          <li>
            Austrians reject the idea of a single, objective interest rate. It is not a number to be calculated or set, but one that <span style={{ color: theme.gold, fontWeight: '500', textDecoration: 'underline', textUnderlineOffset: '3px' }}>emerges</span> from millions of individual time preferences, and the Fed Funds Rate is society's best attempt to track it, invariably <span style={{ color: theme.gold, fontWeight: '500' }}>overshooting or undershooting</span>.
          </li>
          <li>
            When it undershoots, cheap credit floods the economy and entrepreneurs lengthen the capital structure beyond what real savings can support. A <span style={{ color: theme.success, fontWeight: '500' }}>boom</span> follows.
          </li>
          <li>
            When reality reasserts itself, savings aren't there, costs rise, projects fail, and the <span style={{ color: theme.error, fontWeight: '500' }}>bust</span> is the inevitable correction.
          </li>
        </ul>
      </div>

      <FredChart />
    </div>
  );
};

export default FredPage;
